import { render, staticRenderFns } from "./resourceUploaderDialog.vue?vue&type=template&id=5429dc46&scoped=true"
import script from "./resourceUploaderDialog.vue?vue&type=script&lang=js"
export * from "./resourceUploaderDialog.vue?vue&type=script&lang=js"
import style0 from "./resourceUploaderDialog.vue?vue&type=style&index=0&id=5429dc46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5429dc46",
  null
  
)

export default component.exports